@if (!isLoaded) {
<forge-linear-progress></forge-linear-progress>
}
@else {
@if (loadFailed) {
<div class="failedSearch forge-typography--heading2">
    <span>{{loadFailedMessage}}</span>
</div>
}
@if (!hasItems) {
<div fxLayout="row" fxLayoutAlign="center center">
    No Items
</div>
}
@else {
<forge-card class="no-padding">
    @if (title) {
    <h2 class="info-table-card-header">
        {{title}}
    </h2>
    }
    <table mat-table fxFill [dataSource]="tableData" formArrayName="rows">
        @for (column of dataColumns; track column) {
        <ng-container [matColumnDef]="column">
            <th mat-header-cell *matHeaderCellDef>
                <div [ngClass]="getColumnClasses(column)" class="tyl-table-head__cell">
                    {{column}}
                </div>
            </th>
            <td mat-cell *matCellDef="let row">
                @if (!isBoolean(row[column])) {
                <div fxLayout="row" [ngClass]="getColumnClasses(row[column])" class="tyl-table-body__cell"
                    [attr.telemetry]="row[column].Label">
                    @if (row[column].Tooltip) {
                        <forge-tooltip placement="bottom"  [anchor]="'cell-' + row + '-' + column"
                            [innerHTML]="SanitizeValue(row[column].Tooltip)">
                        </forge-tooltip>
                    }
                    <div [id]="'cell-' + row + '-' + column" class="truncated no-wrap" [ngStyle]="getElementStyle(row[column])"
                         [innerHTML]="SanitizeValue(row[column].Value)">
                    </div>
                </div>
                }
                @if (isTrue(row[column])) {
                <div fxLayout="row" fxLayoutAlign="center center">
                    <mat-icon fontIcon="check" class="checkmark">
                    </mat-icon>
                </div>
                }
            </td>
            <td mat-footer-cell *matFooterCellDef>
                @if (getTotal(column)) {
                <div [ngClass]="getColumnClasses(column)">
                    <!-- TODO - why are we assuming the column total is always currency -->
                    {{getTotal(column) | currency}}
                </div>
                }
            </td>
        </ng-container>
        }
        <ng-container matColumnDef="$$commands">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let row">
                <command-bar [commands]="getCommands(row)"></command-bar>
            </td>
            <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="columns"></tr>
        <tr mat-row *matRowDef="let row; columns: columns"></tr>
        <tr mat-footer-row *matFooterRowDef="columns"></tr>
    </table>
</forge-card>
}
}
